export enum EVariants {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TERTIARY = "TERTIARY",
  QUATERNARY = "QUATERNARY",
}
